module.exports = __webpack_public_path__ + "img/sindrome_classificacao.dedf6c88.jpg";